module.exports = __webpack_public_path__ + "assets/img/button-green.78d89c4d.png";